<script lang="ts">
  import { SimpleHeader } from '@athena-lib/Header/SimpleHeader';
  import { get } from 'svelte/store';
  import type { ExpandedHeader } from '$lib/server/expanders/header';
  import { lastUrl } from '$lib/utilities/checkoutDrawerContext.svelte';

  const {
    blok,
    hideBackButton,
  }: {
    blok: ExpandedHeader;
    hideBackButton?: boolean;
  } = $props();

  const headerProps = $derived({
    stickerAppLogoUrl: blok.logo.filename ?? '',
    backUrl: get(lastUrl) ?? blok.checkoutBackUrl,
    hideBackButton,
  });
</script>

<SimpleHeader {...headerProps} />
